"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPageView = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var page = event.page, title = event.title, location = event.location;
    return {
        hitType: 'pageview',
        customTrackerId: tracker,
        page: page,
        title: title,
        location: location,
    };
}; };
exports.trackEvent = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var category = event.category, label = event.label, value = event.value;
    return {
        hitType: 'event',
        customTrackerId: tracker,
        eventCategory: category,
        eventAction: event.action,
        eventLabel: label,
        eventValue: value,
    };
}; };
exports.trackTiming = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var category = event.category, value = event.value, label = event.label;
    return {
        hitType: 'timing',
        customTrackerId: tracker,
        timingCategory: category,
        timingVar: event.var,
        timingValue: value,
        timingLabel: label,
    };
}; };
exports.trackSocialInteraction = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var network = event.network, target = event.target;
    return {
        hitType: 'social',
        customTrackerId: tracker,
        network: network,
        action: event.action,
        target: target,
    };
}; };
exports.trackException = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var exDescription = event.exDescription, exFatal = event.exFatal;
    return {
        hitType: 'exception',
        customTrackerId: tracker,
        exDescription: exDescription,
        exFatal: exFatal,
    };
}; };
exports.trackEcommItem = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var id = event.id, name = event.name, sku = event.sku, category = event.category, price = event.price, quantity = event.quantity;
    return {
        hitType: 'addItem',
        customTrackerId: tracker,
        id: id,
        name: name,
        sku: sku,
        category: category,
        price: price,
        quantity: quantity,
    };
}; };
exports.trackEcommTransaction = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var id = event.id, affiliation = event.affiliation, revenue = event.revenue, shipping = event.shipping, tax = event.tax;
    return {
        hitType: 'addTransaction',
        customTrackerId: tracker,
        id: id,
        affiliation: affiliation,
        revenue: revenue,
        shipping: shipping,
        tax: tax,
    };
}; };
exports.ecommSend = function (tracker) { return function () { return ({
    hitType: 'ecommSend',
    customTrackerId: tracker,
}); }; };
exports.ecommClear = function (tracker) { return function () { return ({
    hitType: 'ecommClear',
    customTrackerId: tracker,
}); }; };
exports.trackEcommImpression = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var id = event.id, name = event.name, list = event.list, brand = event.brand, category = event.category, variant = event.variant, position = event.position, price = event.price;
    if (!id && !name) {
        throw new Error('You must provide an "id" or "name" to track impression data.');
    }
    return {
        ecommType: 'enhanced',
        hitType: 'addImpression',
        customTrackerId: tracker,
        id: id,
        name: name,
        list: list,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
        price: price,
    };
}; };
exports.trackEcommProduct = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var id = event.id, name = event.name, brand = event.brand, category = event.category, variant = event.variant, price = event.price, quantity = event.quantity, coupon = event.coupon, position = event.position;
    if (!id && !name) {
        throw new Error('You must provide an "id" or "name" to track product data.');
    }
    return {
        ecommType: 'enhanced',
        hitType: 'addProduct',
        customTrackerId: tracker,
        id: id,
        name: name,
        brand: brand,
        category: category,
        variant: variant,
        price: price,
        quantity: quantity,
        coupon: coupon,
        position: position,
    };
}; };
exports.trackEcommPromotion = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var id = event.id, name = event.name, creative = event.creative, position = event.position;
    if (!id && !name) {
        throw new Error('You must provide an "id" or "name" to track promotion data.');
    }
    return {
        ecommType: 'enhanced',
        hitType: 'addPromo',
        customTrackerId: tracker,
        id: id,
        name: name,
        creative: creative,
        position: position,
    };
}; };
exports.trackEcommAction = function (eventDef, tracker) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var actionName = event.actionName, id = event.id, affiliation = event.affiliation, revenue = event.revenue, tax = event.tax, shipping = event.shipping, coupon = event.coupon, list = event.list, step = event.step, option = event.option;
    if ((actionName === 'purchase' || actionName === 'refund') && !id) {
        throw new Error('You must provide an "id" when tracking a "purchase" or "refund".');
    }
    return {
        ecommType: 'enhanced',
        hitType: 'addAction',
        customTrackerId: tracker,
        actionName: actionName,
        id: id,
        affiliation: affiliation,
        revenue: revenue,
        tax: tax,
        shipping: shipping,
        coupon: coupon,
        list: list,
        step: step,
        option: option,
    };
}; };
